module.exports = __webpack_public_path__ + "images/5306199ae3707b9d4f32dcdc485dd13b.svg";